var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPreviousStep({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_0_850",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 20,
    width: 20,
    height: 20,
    transform: "rotate(180 20 20)",
    fill: "url(#pattern0_0_850)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_0_850)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -3,
    y: -4,
    width: 23,
    height: 27,
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_0_850",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_0_850",
    transform: "scale(0.0078125)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_0_850",
    width: 128,
    height: 128,
    xlinkHref: "data:image/png;base64,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"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreviousStep);
export default __webpack_public_path__ + "static/media/previousStep.185b9bffa690144c1890b256fff8c73e.svg";
export { ForwardRef as ReactComponent };